import { schema } from "normalizr";
import { studySchema } from "../study";

export const patientSchema = new schema.Entity("patients", {
  studies: [studySchema]
});
